import { useEffect, useState } from "react";
import ApiClientAsync from "../api/ApiClientAsync";

export const useResolveCategories = ({ items, authToken, locale }) => {
  const [resolvedItems, setResolvedItems] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const initial = items.map(item =>
      typeof item?.canShow === "function" ? undefined : item
    );

    setResolvedItems(initial.filter(item => item));

    const resolveAsync = async () => {
      const apiClientAsync = new ApiClientAsync(locale, authToken);

      const resolvedAsyncItems = await Promise.all(
        items.map(async item => {
          if (typeof item?.canShow !== "function") {
            return item;
          }

          try {
            const canShow = await item.canShow({
              apiClient: apiClientAsync
            });

            if (cancelled || !canShow) {
              return;
            }

            return item;
          } catch (e) {
            console.error("canShow failed", e);
          }
        })
      );

      setResolvedItems(resolvedAsyncItems.filter(item => item));
    };

    void resolveAsync();

    return () => {
      cancelled = true;
    };
  }, [items, locale, authToken]);

  return resolvedItems;
};
